<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item> 申报书管理 </el-breadcrumb-item>
      <el-breadcrumb-item>申报书填写</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 搜索框 新增按钮-->
      <el-row class="row-search">
        <el-col class="el-col-user-add">
          <el-input class="user-search" clearable placeholder="请输申报书信息（用空格分隔），支持模糊搜索" v-model="query"
            style="width: 500px">
            <el-button slot="append" icon="el-icon-search" @click.prevent="queryProjectInfo()"></el-button>
          </el-input>
          <!-- 20240920,临时关闭 -->
          <el-button class="bt-user-add" type="success" plain @click.prevent="showAddForm()" disabled>新增申报书</el-button>
        </el-col>
      </el-row>
      <!-- 申报书列表 -->
      <el-table :data="projectInfo" style="width: 100%">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="name" label="名称" width="280"></el-table-column>
        <el-table-column prop="category" label="类别" width="280">
          <!-- <template slot-scope="scope">
            <div>{{scope.row.category}}</div>
          </template> -->
        </el-table-column>
        <el-table-column label="创建时间" width="120">
          <template slot-scope="scope">{{
            scope.row.create_time | fmtdate
          }}</template>
        </el-table-column>
        <!-- 0116 隐藏状态信息 -->
        <el-table-column prop="status" label="状态" width="90">
          <template slot-scope="scope">
            <div>{{ statusName(scope.row.status) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <!-- 申报书查看 -->
            <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
              @click="showInfoForm(scope.row)">
            </el-button>
            <!-- 只有状态为1（待提交）或3（待修改）的才能点击修改按钮 -->
            <el-button size="mini" :plain="true" type="primary" icon="el-icon-edit" circle :disabled="scope.row.status == 1 || scope.row.status == 3 ? false : true
              " @click="showEditForm(scope.row)">
            </el-button>
            <!-- 只有状态为1（待提交）的才能删除 -->
            <el-button size="mini" :plain="true" type="danger" icon="el-icon-delete" circle
              :disabled="scope.row.status == 111 ? false : true" @click="showDeleteForm(scope.row.id)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 申报书新增 -->
    <el-card v-show="addFormVisible" id="id-el-card-add">
      <el-col>
        <div class="header-edit">新增申报书</div>
      </el-col>
      <!-- 课题类别 -->
      <el-card>
        <el-col class="el-col-addForm">
          <span> 课题类别：</span>
          <el-select v-model="addForm.category" @change="changeCategory" filterable allow-create default-first-option
            placeholder="请选择课题类别">
            <el-option v-for="item in projectCategorys" :key="item.name" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-col>

        <el-col class="el-col-addForm">
          <span> 课题方向：</span>
          <el-select v-model="addForm.category_direction" @change="changeDirection" filterable allow-create
            default-first-option placeholder="请选择课题类别方向">
            <el-option v-for="item in projectDirections" :key="item.name" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-col>
      </el-card>
      <el-card>
        <el-col class="el-col-addForm">
          <span> 课题名称：</span>
          <el-select v-model="addForm.name" filterable allow-create default-first-option placeholder="请选择课题名称">
            <el-option v-for="item in projectNames" :key="item.name" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
          <!-- <el-input v-model="addForm.name"></el-input> -->
        </el-col>
      </el-card>
      <!-- 项目主持人情况 -->
      <el-card class="el-card-leader">
        <div class="div-leader">
          课题组基本情况
        </div>
        <div class="leader-table">
          <table>
            <tbody>
              <tr>
                <td colspan="8">
                  <span style="font-weight: bold;">项目主持人情况</span>
                  <el-button type="primary" size="mini" style="margin-left: 10px;" @click="showEditLeader()">修改信息
                  </el-button>
                </td>
              </tr>
              <tr>
                <!-- <th rowspan="6" class="th1">项目主持人情况</th> -->
                <td class="col1">姓名</td>
                <td class="col1">{{ leader.username }}</td>
                <td class="col2">性别</td>
                <td class="col2">{{ leader.gender }}</td>
                <td class="col2">民族</td>
                <td class="col2">{{ leader.national }}</td>
                <td class="col1">出生年月</td>
                <td class="col3">{{ leader.birth }}</td>
              </tr>
              <tr>
                <td class="col1">行政职务</td>
                <td class="col1">{{ leader.duty }}</td>
                <td colspan="2">专业职称</td>
                <td colspan="2">{{ leader.title }}</td>
                <td>研究专长</td>
                <td class="col3">{{ leader.major }}</td>
              </tr>
              <tr>
                <td>最后学历</td>
                <td>{{ leader.education }}</td>
                <td colspan="2">最后学位</td>
                <td colspan="2">{{ leader.degree }}</td>
                <td class="col1" style="line-height: 20px">
                  所在省（自治区、直辖市）
                </td>
                <td class="col3">{{ leader.province }}</td>
              </tr>
              <tr>
                <td>工作单位</td>
                <td colspan="7" style="width: 568px; line-height: 30px">
                  {{ leader.organization }}
                </td>
              </tr>
              <tr>
                <td>联系电话</td>
                <td colspan="3">{{ leader.tel }}</td>
                <td colspan="2">E-mail</td>
                <td colspan="2">{{ leader.email }}</td>
              </tr>
              <tr>
                <td>通讯地址</td>
                <td colspan="5">{{ leader.addr }}</td>
                <td>邮政编码</td>
                <td>{{ leader.zipcode }}</td>
              </tr>
            </tbody>
          </table>

          <table class="table-member">
            <tbody>
              <tr>
                <td colspan="6">
                  <h3>注意：参加者人数不能多于{{ projectMemberNumber }}人！</h3>
                  <span style="font-weight: bold;"> 主要参加者情况</span>
                  <el-button type="primary" size="mini" style="margin-left: 10px;" @click="showAddMember()">新增参加者
                  </el-button>
                </td>
              </tr>
              <tr>
                <!-- <th rowspan="10" class="th1">主要参加者情况</th> -->
                <td class="col1">姓名</td>
                <td style="width: 130px">单位</td>
                <td style="width: 88px">最后学历</td>
                <td style="width: 88px">所学专业</td>
                <td style="width: 100px">技术职务</td>
                <td style="width: 150px">研究分工</td>
              </tr>

              <tr v-for="m in projectMember" :key="m.index">
                <td class="col1">&nbsp;{{ m.name }}&nbsp;</td>
                <td style="width: 130px">{{ m.organization }}</td>
                <td style="width: 88px">{{ m.education }}</td>
                <td style="width: 88px">{{ m.major }}</td>
                <td style="width: 100px">{{ m.duty }}</td>
                <td style="width: 150px">{{ m.division }}</td>
                <td style="width:100px;border:0">
                  <el-button size="mini" :plain="true" type="primary" icon="el-icon-edit" circle
                    @click="showEditMember(m)"></el-button>
                  <el-button size="mini" :plain="true" type="danger" icon="el-icon-delete" circle
                    @click="deleteMemberButton(m)"></el-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 预期成果形式 -->
        <div class="result_type">
          <div>预期成果形式：（研究报告、视频、图片，技术资料等）</div>
          <div>
            <el-input class="input-result-type" type="textarea" :rows="2" v-model="addForm.result_type"></el-input>
          </div>
        </div>

        <div class="total_words">
          <span> 字数：</span>
          <el-input v-model="addForm.total_words"></el-input>

          <span> 预计完成时间：</span>
          <el-date-picker v-model="addForm.complete_time" type="date" placeholder=" 选择日期" format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
      </el-card>
      <!-- 课题研究计划 -->
      <el-card>
        <div style="font-size: 24px;">课题研究计划</div>
        <div style="margin-top: 10px; color:red;">
          <p>
            注意：课题论证和研究计划内容不少于800字，不超过6000字；编辑内容时，6个标题予以保留！
          </p>
          <p>如需插入图片，请调整图片大小不要超过编辑器尺寸。</p>
        </div>
        <quill-editor v-model="addForm.content" :options="editorOption" class="editor" ref="myQuillEditorAdd"
          @change="onEditorChange($event)">
        </quill-editor>
        <div style="margin-top: 10px;">
          字数：{{ TiLengthAdd }}/{{ TiLengthTotal }}
        </div>
      </el-card>

      <el-card>
        <!-- 课题申报情况及课题研究基础 -->
        <div class="div-leader-indroduction">
          <span style="font-size: 24px;">课题申报情况及课题研究基础</span>
        </div>
        <div style="margin-top: 10px;color:red;">
          注意：编辑内容时，2个标题予以保留！
        </div>
        <quill-editor v-model="addForm.leader_introduction" :options="editorOption" class="editor"></quill-editor>

        <!-- 填写预算 -->
        <el-button type="warning" @click="editBudget()" style="margin-top: 20px;">填写课题经费预算</el-button>

        <div>
          <div style="margin-top: 20px;">
            <p>说明：</p>
            <p>
              1、填写过程中可以点击页面右下角“保存”按钮临时保存，下次可点击课题列表中的“编辑”继续填写
            </p>
            <p>2、填写完毕，点击“生成申报书并下载”按钮，下载生成的申报书文档</p>
            <p>
              3、将生成的《申请书》、《前期研究成果》、《在研课题证明》全部打印盖章、扫描后，转换成pdf格式文件，
              点击下方“上传附件”按钮将文件上传（文件名必须分别包含"申请书"、"前期研究成果"、"在研课题证明"）
            </p>
            <p>4、点击页面右下角“提交审核”按钮进行审核</p>
            <!-- <el-button type="primary" @click="genPdf">测试生成</el-button> -->
          </div>
          <el-button type="primary" style="margin-top: 20px;" @click="genPdf('add')">生成申报书并下载</el-button>
        </div>
        <div class="div-file">
          <!-- 上传附件 -->
          <div>
            注意：上传的文件名必须分别包含"申请书"、"前期研究成果"、"在研课题证明"
          </div>
          <div class="div-upload">
            <input type="file" value="" class="input-upload" @change="uploadFile" />
            <el-button type="primary" size="small" class="button-upload">上传附件
              <i class="el-icon-upload el-icon--right"></i>
            </el-button>
          </div>

          <!-- 文件列表 -->
          <el-table :data="fileList" border style="width:551px;" :header-cell-style="{ background: '#fafafa' }">
            <el-table-column prop="name" label="文件名" width="300"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150">
              <template slot-scope="scope">
                {{ scope.row.create_time | fmtdate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-download" circle
                  @click="downloadFile(scope.row)"></el-button>
                <el-button size="mini" :plain="true" type="danger" icon="el-icon-delete" circle
                  @click="deleteFile(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
      <!-- 保存、提交按钮 -->
      <div class="div-add">
        <el-button type="primary" @click.prevent="addProject()" class="el-button-add">保存</el-button>
        <el-button type="primary" @click.prevent="submitProject()" class="el-button-add">提交审核</el-button>
      </div>
    </el-card>

    <!-- 申报书修改 -->
    <el-card v-show="editFormVisible" id="id-el-card-edit">
      <el-row>
        <el-col :span="24">
          <div class="header-edit">修改申报书</div>
        </el-col>
      </el-row>
      <!-- 审核意见 -->
      <el-card v-if="auditInfo.info">
        <div style="margin-bottom: 10px;font-size: 16px;">审核意见</div>
        <quill-editor :disabled="true" v-model="auditInfo.info" :options="editorOptionAudit" class="editor-audit">
        </quill-editor>
      </el-card>

      <el-card>
        <el-col class="el-col-addForm">
          <span> 课题类别：</span>
          <!-- <span>{{projectCategory.name}}</span> -->
          <el-select v-model="editForm.category" @change="changeCategory" filterable allow-create default-first-option
            placeholder="请选择课题类别">
            <el-option v-for="item in projectCategorys" :key="item.name" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-col>
        <el-col class="el-col-addForm">
          <span> 课题方向：</span>
          <el-select v-model="editForm.category_direction" @change="changeDirection" filterable allow-create
            default-first-option placeholder="请选择课题类别方向">
            <el-option v-for="item in projectDirections" :key="item.name" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-col>
      </el-card>

      <el-card>
        <el-col class="el-col-addForm">
          <span> 课题名称：</span>
          <el-select v-model="editForm.name" filterable allow-create default-first-option placeholder="请选择课题名称">
            <el-option v-for="item in projectNames" :key="item.name" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
          <!-- <el-input v-model="editForm.name"></el-input> -->
        </el-col>
      </el-card>

      <!-- 项目主持人情况 -->
      <el-card class="el-card-leader">
        <div class="leader-table">
          <table>
            <tbody>
              <tr>
                <td colspan="8">
                  <span style="font-weight: bold;">项目主持人情况</span>
                  <el-button type="primary" size="mini" style="margin-left: 10px;" @click="showEditLeader()">修改信息
                  </el-button>
                </td>
              </tr>
              <tr>
                <!-- <th rowspan="6" class="th1">项目主持人情况</th> -->
                <td class="col1">姓名</td>
                <td class="col1">{{ leader.username }}</td>
                <td class="col2">性别</td>
                <td class="col2">{{ leader.gender }}</td>
                <td class="col2">民族</td>
                <td class="col2">{{ leader.national }}</td>
                <td class="col1">出生年月</td>
                <td class="col3">{{ leader.birth }}</td>
              </tr>
              <tr>
                <td class="col1">行政职务</td>
                <td class="col1">{{ leader.duty }}</td>
                <td colspan="2">专业职称</td>
                <td colspan="2">{{ leader.title }}</td>
                <td>研究专长</td>
                <td class="col3">{{ leader.major }}</td>
              </tr>
              <tr>
                <td>最后学历</td>
                <td>{{ leader.education }}</td>
                <td colspan="2">最后学位</td>
                <td colspan="2">{{ leader.degree }}</td>
                <td class="col1" style="line-height: 20px">
                  所在省（自治区、直辖市）
                </td>
                <td class="col3">{{ leader.province }}</td>
              </tr>
              <tr>
                <td>工作单位</td>
                <td colspan="7" style="width: 568px; line-height: 30px">
                  {{ leader.organization }}
                </td>
              </tr>
              <tr>
                <td>联系电话</td>
                <td colspan="3">{{ leader.tel }}</td>
                <td colspan="2">E-mail</td>
                <td colspan="2">{{ leader.email }}</td>
              </tr>
              <tr>
                <td>通讯地址</td>
                <td colspan="5">{{ leader.addr }}</td>
                <td>邮政编码</td>
                <td>{{ leader.zipcode }}</td>
              </tr>
            </tbody>
          </table>

          <table class="table-member">
            <tbody>
              <tr>
                <td colspan="6">
                  <h3>注意：参加者人数不能多于{{ projectMemberNumber }}人！</h3>
                  <span style="font-weight: bold;"> 主要参加者情况</span>
                  <el-button type="primary" size="mini" style="margin-left: 10px;" @click="showAddMember()">新增参加者
                  </el-button>
                </td>
              </tr>
              <tr>
                <!-- <th rowspan="10" class="th1">主要参加者情况</th> -->
                <td class="col1">姓名</td>
                <td style="width: 130px">单位</td>
                <td style="width: 88px">最后学历</td>
                <td style="width: 88px">所学专业</td>
                <td style="width: 100px">技术职务</td>
                <td style="width: 150px">研究分工</td>
              </tr>

              <tr v-for="m in projectMember" :key="m.index">
                <td class="col1">&nbsp;{{ m.name }}&nbsp;</td>
                <td style="width: 130px">{{ m.organization }}</td>
                <td style="width: 88px">{{ m.education }}</td>
                <td style="width: 88px">{{ m.major }}</td>
                <td style="width: 100px">{{ m.duty }}</td>
                <td style="width: 150px">{{ m.division }}</td>
                <td style="width:100px;border:0">
                  <el-button size="mini" :plain="true" type="primary" icon="el-icon-edit" circle
                    @click="showEditMember(m)"></el-button>
                  <el-button size="mini" :plain="true" type="danger" icon="el-icon-delete" circle
                    @click="deleteMemberButton(m)"></el-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 预期成果形式 -->
        <div class="result_type">
          <div>预期成果形式：（研究报告、视频、图片，技术资料等）</div>
          <div>
            <el-input class="input-result-type" type="textarea" :rows="2" v-model="editForm.result_type"></el-input>
          </div>
        </div>

        <div class="total_words">
          <span> 字数：</span>
          <el-input v-model="editForm.total_words"></el-input>

          <span> 预计完成时间：</span>
          <el-date-picker v-model="editForm.complete_time" type="date" placeholder=" 选择日期" format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
      </el-card>
      <!-- 课题研究计划 -->
      <el-card>
        <div style="font-size: 24px;">课题研究计划</div>
        <div style="margin-top: 10px; color:red;">
          <p>
            注意：课题论证和研究计划内容不少于800字，不超过6000字；编辑内容时，6个标题予以保留！
          </p>
          <p>如需插入图片，请调整图片大小不要超过编辑器尺寸。</p>
        </div>
        <quill-editor v-model="editContent" :options="editorOption" class="editor" ref="myQuillEditorEdit"
          @change="onEditorChange($event)">
        </quill-editor>
        <div style="margin-top: 10px;">
          字数：{{ TiLengthEdit }}/{{ TiLengthTotal }}
        </div>
      </el-card>

      <el-card>
        <!-- 课题申报情况及课题研究基础 -->
        <div class="div-leader-indroduction">
          <span style="font-size: 24px;">课题申报情况及课题研究基础</span>
        </div>
        <div style="margin-top: 10px;color:red;">
          注意：编辑内容时，2个标题予以保留！
        </div>
        <quill-editor v-model="leader_introduction_temp" :options="editorOption" class="editor"></quill-editor>

        <!-- 填写预算 -->
        <el-button type="warning" @click="editBudget()" style="margin-top: 20px;">修改课题经费预算</el-button>

        <div>
          <div>
            <p>说明：</p>
            <p>
              1、填写过程中可以点击页面右下角“保存”按钮临时保存，下次可点击课题列表中的“编辑”继续填写
            </p>
            <p>2、填写完毕，点击“生成申报书并下载”按钮，下载生成的申报书文档</p>
            <p>
              3、将生成的《申请书》、《前期研究成果》、《在研课题证明》全部打印盖章、扫描后，转换成pdf格式文件，
              点击下方“上传附件”按钮将文件上传（文件名必须分别包含"申请书"、"前期研究成果"、"在研课题证明"）
            </p>
            <p>4、点击页面右下角“提交审核”按钮进行审核</p>
            <!-- <el-button type="primary" @click="genPdf">测试生成</el-button> -->
          </div>
          <el-button type="primary" style="margin-top: 20px;" @click="genPdf('edit')">生成申报书并下载</el-button>
        </div>
        <div class="div-file">
          <!-- 上传附件 -->
          <div>
            注意：上传的文件名必须分别包含"申请书"、"前期研究成果"、"在研课题证明"
          </div>
          <div class="div-upload">
            <input type="file" value="" class="input-upload" @change="uploadFileEdit" />
            <el-button type="primary" size="small" class="button-upload">上传附件
              <i class="el-icon-upload el-icon--right"></i>
            </el-button>
          </div>
          <!-- 文件列表 -->
          <el-table :data="fileList" border style="width:551px;" :header-cell-style="{ background: '#fafafa' }">
            <el-table-column prop="name" label="文件名" width="300"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150">
              <template slot-scope="scope">
                {{ scope.row.create_time | fmtdate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-download" circle
                  @click="downloadFile(scope.row)"></el-button>
                <el-button size="mini" :plain="true" type="danger" icon="el-icon-delete" circle
                  @click="deleteFile(scope.row)">
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
      <!-- 保存、提交按钮 -->
      <div class="div-add">
        <el-button type="primary" @click.prevent="editProject()" class="el-button-add">保存</el-button>
        <el-button type="primary" @click.prevent="submitProjectEdit()" class="el-button-add">提交审核</el-button>
      </div>
    </el-card>

    <!-- 申报书查看 -->
    <el-card v-show="infoFormVisible" id="id-el-card-info">
      <el-row>
        <el-col :span="24">
          <div class="header-edit">申报书详情</div>
        </el-col>
      </el-row>
      <el-card>
        <el-col class="el-col-addForm">
          <span> 课题方向：</span>
          <span>{{ editForm.category_direction }}</span>
          <span style="margin-left: 30px;"> 课题名称：</span>
          <el-input :disabled="true" v-model="editForm.name"></el-input>
        </el-col>
      </el-card>
      <!-- 项目主持人情况 -->
      <el-card class="el-card-leader">
        <div class="leader-table">
          <table>
            <tbody>
              <tr>
                <td colspan="8">
                  <span style="font-weight: bold;">项目主持人情况</span>
                </td>
              </tr>
              <tr>
                <!-- <th rowspan="6" class="th1">项目主持人情况</th> -->
                <td class="col1">姓名</td>
                <td class="col1">{{ leader.username }}</td>
                <td class="col2">性别</td>
                <td class="col2">{{ leader.gender }}</td>
                <td class="col2">民族</td>
                <td class="col2">{{ leader.national }}</td>
                <td class="col1">出生年月</td>
                <td class="col3">{{ leader.birth }}</td>
              </tr>
              <tr>
                <td class="col1">行政职务</td>
                <td class="col1">{{ leader.duty }}</td>
                <td colspan="2">专业职称</td>
                <td colspan="2">{{ leader.title }}</td>
                <td>研究专长</td>
                <td class="col3">{{ leader.major }}</td>
              </tr>
              <tr>
                <td>最后学历</td>
                <td>{{ leader.education }}</td>
                <td colspan="2">最后学位</td>
                <td colspan="2">{{ leader.degree }}</td>
                <td class="col1" style="line-height: 20px">
                  所在省（自治区、直辖市）
                </td>
                <td class="col3">{{ leader.province }}</td>
              </tr>
              <tr>
                <td>工作单位</td>
                <td colspan="7" style="width: 568px; line-height: 30px">
                  {{ leader.organization }}
                </td>
              </tr>
              <tr>
                <td>联系电话</td>
                <td colspan="3">{{ leader.tel }}</td>
                <td colspan="2">E-mail</td>
                <td colspan="2">{{ leader.email }}</td>
              </tr>
              <tr>
                <td>通讯地址</td>
                <td colspan="5">{{ leader.addr }}</td>
                <td>邮政编码</td>
                <td>{{ leader.zipcode }}</td>
              </tr>
            </tbody>
          </table>

          <table class="table-member">
            <tbody>
              <tr>
                <td colspan="6">
                  <span style="font-weight: bold;"> 主要参加者情况</span>
                </td>
              </tr>
              <tr>
                <!-- <th rowspan="10" class="th1">主要参加者情况</th> -->
                <td class="col1">姓名</td>
                <td style="width: 130px">单位</td>
                <td style="width: 88px">最后学历</td>
                <td style="width: 88px">所学专业</td>
                <td style="width: 100px">技术职务</td>
                <td style="width: 150px">研究分工</td>
              </tr>

              <tr v-for="m in projectMember" :key="m.index">
                <td class="col1">&nbsp;{{ m.name }}&nbsp;</td>
                <td style="width: 130px">{{ m.organization }}</td>
                <td style="width: 88px">{{ m.education }}</td>
                <td style="width: 88px">{{ m.major }}</td>
                <td style="width: 100px">{{ m.duty }}</td>
                <td style="width: 150px">{{ m.division }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </el-card>
      <!-- 预期成果形式 -->
      <el-card>
        <el-row class="el-row-detail">
          <el-col :span="8"><span> 预期成果形式：</span>
            <el-input :disabled="true" v-model="editForm.result_type"></el-input>
          </el-col>
          <el-col :span="8"><span style="margin-left: 30px;"> 字数：</span>
            <el-input :disabled="true" v-model="editForm.total_words"></el-input>
          </el-col>
          <el-col :span="8"><span> 预计完成时间：</span>
            <el-input :disabled="true" v-model="editForm.complete_time"></el-input>
          </el-col>
        </el-row>
      </el-card>
      <!-- 课题研究计划 -->
      <el-card>
        <div>课题研究计划</div>
        <quill-editor :disabled="true" v-model="editForm.content" :options="editorOption" class="editor"></quill-editor>
        <!-- 课题申报情况及课题研究基础 -->
        <div class="div-leader-indroduction">
          <span style="font-size: 24px;">课题申报情况及课题研究基础</span>
        </div>
        <div style="margin-top: 10px;color:red;"></div>
        <quill-editor :disabled="true" v-model="editForm.leader_introduction" :options="editorOption" class="editor">
        </quill-editor>

        <div class="div-file">
          <!-- 文件列表 -->
          <el-table :data="fileList" border style="width:551px;" :header-cell-style="{ background: '#fafafa' }">
            <el-table-column prop="name" label="文件名" width="300"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150">
              <template slot-scope="scope">
                {{ scope.row.create_time | fmtdate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-download" circle
                  @click="downloadFile(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </el-card>

    <!-- 对话框 -->
    <!-- 编辑主持人对话框 -->
    <el-dialog title="编辑主持人信息" :visible.sync="editLeaderVisible">
      <el-form label-position="right" label-width="180px" :model="leader" :rules="leaderRules" class="demo-ruleForm">
        <el-form-item label="姓名" prop="username">
          <el-input v-model="leader.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-input v-model="leader.gender" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="民族" prop="national">
          <el-input v-model="leader.national" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="出生年月" prop="birth">
          <el-input v-model="leader.birth" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="行政职务" prop="duty">
          <el-input v-model="leader.duty" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="专业职称" prop="title">
          <el-input v-model="leader.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="研究专长" prop="major">
          <el-input v-model="leader.major" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="最后学历" prop="education">
          <el-input v-model="leader.education" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="最后学位" prop="degree">
          <el-input v-model="leader.degree" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="所在省(自治区、直辖市)" prop="province">
          <el-input v-model="leader.province" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="工作单位" prop="organization">
          <el-input v-model="leader.organization" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="tel">
          <el-input v-model="leader.tel" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="E-mail" prop="email">
          <el-input v-model="leader.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="通讯地址" prop="addr">
          <el-input v-model="leader.addr" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮政编码" prop="zipcode">
          <el-input v-model="leader.zipcode" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editLeaderVisible = false">取 消</el-button>
        <el-button type="primary" @click="editLeader()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 新增参加者对话框 -->
    <el-dialog title="新增参加者信息" :visible.sync="addMemberVisible">
      <el-form label-position="right" label-width="80px" :model="addMember" :rules="memberRules">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="addMember.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="单位" prop="organization">
          <el-input v-model="addMember.organization" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="最后学历" prop="education">
          <el-input v-model="addMember.education" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="所学专业" prop="major">
          <el-input v-model="addMember.major" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="技术职务" prop="duty">
          <el-input v-model="addMember.duty" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="研究分工" prop="division">
          <el-input v-model="addMember.division" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addMemberVisible = false">取 消</el-button>
        <el-button type="primary" @click="addMemberButton()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑参加者对话框 -->
    <el-dialog title="编辑参加者信息" :visible.sync="editMemberVisible">
      <el-form label-position="right" label-width="80px" :model="addMember" :rules="memberRules">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="addMember.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="单位" prop="organization">
          <el-input v-model="addMember.organization" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="最后学历" prop="education">
          <el-input v-model="addMember.education" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="所学专业" prop="major">
          <el-input v-model="addMember.major" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="技术职务" prop="duty">
          <el-input v-model="addMember.duty" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="研究分工" prop="division">
          <el-input v-model="addMember.division" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editMemberButton()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 课题预算表对话框 -->
    <el-dialog title="课题经费预算" :visible.sync="budgetVisible">
      <div class="div-budget">
        <div>
          <table>
            <tr>
              <td>序号</td>
              <td>预算科目名称</td>
              <td>预算金额（万元）</td>
              <td>测算依据（另附页说明）</td>
            </tr>
            <tr>
              <td>1</td>
              <td>经费总额</td>
              <td>
                <el-input v-model="budget.f1"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s1"></el-input>
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>一、直接费用</td>
              <td>
                <el-input v-model="budget.f2"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s2"></el-input>
              </td>
            </tr>
            <tr>
              <td>3</td>
              <td>1.设备费</td>
              <td>
                <el-input v-model="budget.f3"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s3"></el-input>
              </td>
            </tr>
            <tr>
              <td>4</td>
              <td>（1）购置设备费</td>
              <td>
                <el-input v-model="budget.f4"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s4"></el-input>
              </td>
            </tr>
            <tr>
              <td>5</td>
              <td>（2）试制设备费</td>
              <td>
                <el-input v-model="budget.f5"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s5"></el-input>
              </td>
            </tr>
            <tr>
              <td>6</td>
              <td>（3）设备改造与租赁费</td>
              <td>
                <el-input v-model="budget.f6"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s6"></el-input>
              </td>
            </tr>
            <tr>
              <td>7</td>
              <td>2.材料费</td>
              <td>
                <el-input v-model="budget.f7"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s7"></el-input>
              </td>
            </tr>
            <tr>
              <td>8</td>
              <td>3.测试化验加工费</td>
              <td>
                <el-input v-model="budget.f8"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s8"></el-input>
              </td>
            </tr>
            <tr>
              <td>9</td>
              <td>4.差旅费</td>
              <td>
                <el-input v-model="budget.f9"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s9"></el-input>
              </td>
            </tr>
            <tr>
              <td>10</td>
              <td>其中：市内交通费</td>
              <td>
                <el-input v-model="budget.f10"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s10"></el-input>
              </td>
            </tr>
            <tr>
              <td>11</td>
              <td>5.会议费</td>
              <td>
                <el-input v-model="budget.f11"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s11"></el-input>
              </td>
            </tr>
            <tr>
              <td>12</td>
              <td>6.出版/印刷/文献/信息传播/知识产权事务费</td>
              <td>
                <el-input v-model="budget.f12"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s12"></el-input>
              </td>
            </tr>
            <tr>
              <td>13</td>
              <td>7.劳务费</td>
              <td>
                <el-input v-model="budget.f13"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s13"></el-input>
              </td>
            </tr>
            <tr>
              <td>14</td>
              <td>8.专家咨询费</td>
              <td>
                <el-input v-model="budget.f14"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s14"></el-input>
              </td>
            </tr>
            <tr>
              <td>15</td>
              <td>二、间接经费（不得超过课题经费总额的10%）</td>
              <td>
                <el-input v-model="budget.f15"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s15"></el-input>
              </td>
            </tr>
            <tr>
              <td>16</td>
              <td>1.管理费用</td>
              <td>
                <el-input v-model="budget.f16"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s16"></el-input>
              </td>
            </tr>
            <tr>
              <td>17</td>
              <td>2.其他具体说明</td>
              <td>
                <el-input v-model="budget.f17"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s17"></el-input>
              </td>
            </tr>
          </table>

          <div style="margin-top: 20px;">
            <span style="font-size: 20px;">测算依据说明:</span>
          </div>
          <quill-editor v-model="budget.reason" :options="editorOption" class="editor"></quill-editor>

          <div class="div-but">
            <el-button type="primary" @click="budgetButton">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//富文本
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import * as Quill from "quill";
import { quillEditor } from "vue-quill-editor";
import { ImageDrop } from "quill-image-drop-module";
import ImageResize from "quill-image-resize-module";
Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);

//下载
import fileDownload from "js-file-download";

export default {
  components: {
    quillEditor
  },
  data() {
    return {
      // 20230505 新增 参加者人数限制
      projectMemberNumber: 9,
      // 20230426 新增字数限制
      TiLengthTotal: 0,
      TiLengthAdd: 0,
      TiLengthEdit: 0,

      editContent: "", // 中间变量，quill的坑
      leader_introduction_temp: "", // 中间变量，quill的坑

      pid: "",
      userid: "",
      query: "", //查询条件
      projectInfo: [],

      //20230403 新增申报截至时间
      endDate: "",
      // 202303新增青年课题条件
      isYouth: false,
      projectCategorys: [], //课题类别列表
      projectCategory: {}, //课题类别
      projectDirections: [], //课题方向

      // 20230424新增课题名称列表，用户只能选取不能编辑。从课题类别json中读取
      projectNames: [],

      projectStatus: [],
      status: "",
      projectLeader: [], //主持人，返回的是列表
      leader: {}, //主持人，取列表第一项
      projectMember: [], //本项目参加人
      addFormVisible: false, //显示新增卡片
      addForm: {
        content:
          '<div style="font-size: 24px; color:red;">\
                  <h3>1、本课题研究的理论意义和实践意义</h3> </br></br></br></br></br></br>\
                  <h3>2、研究的重点和难点</h3> </br></br></br></br></br></br>\
                  <h3>3、研究方法和途径（体育专题研究课题请写明采取的主要工作方法、主要技术路线、主要指标及可行性分析）</h3> </br></br></br></br></br></br>\
                  <h3>4、研究的主要内容（体育专题研究课题请写明工作实施方案、地点、时间）</h3> </br></br></br></br></br></br>\
                  <h3>5、本课题的创新</h2> </br></br></br></br></br></br>\
                  <h3>6、研究进度安排</h2> </br></br></br></br></br></br></div>',
        leader_introduction:
          "<h3>1、课题负责人个人基本情况、主要学术简历</h2></br></br></br></br></br></br><h3>2、与本课题相关的主要研究成果（近5年来主持课题/科技服务项目、发表论文及出版的专著，应注明成果名称、成果形式、发表刊物或出版单位及时间）</h3> </br></br></br></br></br></br>"
      },
      infoFormVisible: false,
      budget: {}, //课题预算，初始化为null，提交时判断
      budgetVisible: false,
      editForm: {}, //编辑申报书
      editFormVisible: false, // 显示编辑卡片
      auditInfo: {},
      editLeaderVisible: false, //显示编辑主持人对话框
      addMemberVisible: false, //显示新增参加人对话框
      addMember: {}, //新增参加人信息（编辑参加人也用）
      editMemberVisible: false, //显示编辑参加者对话
      fileList: [], //附件列表
      // qill-editor
      editorOption: {
        modules: {
          imageDrop: true, //图片拖拽
          imageResize: {
            //放大缩小
            displaySize: true
          },
          toolbar: [
            ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
            ["blockquote", "code-block"], // 引用  代码块
            [
              {
                header: 1
              },
              {
                header: 2
              }
            ], // 1、2 级标题
            [
              {
                list: "ordered"
              },
              {
                list: "bullet"
              }
            ], // 有序、无序列表
            [
              {
                script: "sub"
              },
              {
                script: "super"
              }
            ], // 上标/下标
            [
              {
                indent: "-1"
              },
              {
                indent: "+1"
              }
            ], // 缩进
            [
              {
                direction: "rtl"
              }
            ], // 文本方向
            [
              {
                size: ["small", false, "large", "huge"]
              }
            ], // 字体大小
            [
              {
                header: [1, 2, 3, 4, 5, 6, false]
              }
            ], // 标题
            [
              {
                color: []
              },
              {
                background: []
              }
            ], // 字体颜色、字体背景颜色
            [
              {
                font: []
              }
            ], // 字体种类
            [
              {
                align: []
              }
            ], // 对齐方式
            ["clean"], // 清除文本格式
            ["link", "image", "video"], // 链接、图片、视频
            // 表格
            [
              {
                table: "TD"
              },
              {
                "table-insert-row": "TIR"
              },
              {
                "table-insert-column": "TIC"
              },
              {
                "table-delete-row": "TDR"
              },
              {
                "table-delete-column": "TDC"
              }
            ]
          ] //工具菜单栏配置
        },
        placeholder: "",
        readyOnly: false, //是否只读
        theme: "snow" //主题 snow/bubble
      },
      editorOptionAudit: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
            ["blockquote", "code-block"], // 引用  代码块
            [
              {
                header: 1
              },
              {
                header: 2
              }
            ], // 1、2 级标题
            [
              {
                list: "ordered"
              },
              {
                list: "bullet"
              }
            ] // 有序、无序列表
          ] //工具菜单栏配置
        }
      }, //审核意见
      // 成果形式
      optionsResult_type: ["研究报告", "其他"],
      leaderRules: {
        username: [
          {
            required: true,
            message: "姓名不能为空",
            trigger: "blur"
          }
        ],
        gender: [
          {
            required: true,
            message: "性别不能为空",
            trigger: "blur"
          }
        ],
        national: [
          {
            required: true,
            message: "民族不能为空",
            trigger: "blur"
          }
        ],
        birth: [
          {
            required: true,
            message: "出生年月不能为空",
            trigger: "blur"
          }
        ],
        duty: [
          {
            required: true,
            message: "行政职务不能为空",
            trigger: "blur"
          }
        ],
        title: [
          {
            required: true,
            message: "专业职称不能为空",
            trigger: "blur"
          }
        ],
        major: [
          {
            required: true,
            message: "研究专长不能为空",
            trigger: "blur"
          }
        ],
        education: [
          {
            required: true,
            message: "最后学历不能为空",
            trigger: "blur"
          }
        ],
        degree: [
          {
            required: true,
            message: "最后学位不能为空",
            trigger: "blur"
          }
        ],
        province: [
          {
            required: true,
            message: "所在省(自治区、直辖市)不能为空",
            trigger: "blur"
          }
        ],
        organization: [
          {
            required: true,
            message: "工作单位不能为空",
            trigger: "blur"
          }
        ],
        tel: [
          {
            required: true,
            message: "联系电话不能为空",
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            message: "E-mail不能为空",
            trigger: "blur"
          }
        ],
        addr: [
          {
            required: true,
            message: "通讯地址不能为空",
            trigger: "blur"
          }
        ],
        zipcode: [
          {
            required: true,
            message: "邮政编码不能为空",
            trigger: "blur"
          }
        ]
      }, //主持人input规则
      memberRules: {
        name: [
          {
            required: true,
            message: "姓名不能为空",
            trigger: "blur"
          }
        ],
        organization: [
          {
            required: true,
            message: "单位不能为空",
            trigger: "blur"
          }
        ],
        education: [
          {
            required: true,
            message: "最后学历不能为空",
            trigger: "blur"
          }
        ],
        major: [
          {
            required: true,
            message: "所学专业不能为空",
            trigger: "blur"
          }
        ],
        duty: [
          {
            required: true,
            message: "技术职务不能为空",
            trigger: "blur"
          }
        ],
        division: [
          {
            required: true,
            message: "研究分工不能为空",
            trigger: "blur"
          }
        ]
      } //参加者input规则
    };
  },

  created() {
    this.getProjectCategorys();
    this.userid = localStorage.getItem("userid");
    this.username = localStorage.getItem("username");
    this.getProjectInfo();
    this.getProjectStatus();
    //创建pid
    this.pid = new Date().getTime().toString() + this.username;

    this.getProjectLeader();
    this.getEndDate();
    this.getTiLengthTotal();
  },

  mounted() { },
  methods: {
    // 20230426 新增字数限制
    async getTiLengthTotal() {
      let resGet = await this.axios.get("/sysDic/?name=研究计划字数限制");
      if (resGet.status == 200) {
        // 表里有初始化数据
        if (resGet.data.results.length == 1) {
          this.TiLengthTotal = resGet.data.results[0].value;
        } else {
          return this.$message.error(
            "“研究计划字数限制”未设置，请联系管理员进行设置！"
          );
        }
      }
    },
    onEditorChange(e) {
      this.TiLengthAdd = e.quill.getLength() - 1;
      this.TiLengthEdit = e.quill.getLength() - 1;
    },

    //20230403 新增从字典中获取申报截至日期，判断申报人年龄
    async getEndDate() {
      let resGet = await this.axios.get("/sysDic/?name=申报截至日期");
      if (resGet.status == 200) {
        // 表里有初始化数据
        if (resGet.data.results.length == 1) {
          this.endDate = resGet.data.results[0].value;
        } else {
          return this.$message.error(
            "申报截至日期未设置，请联系管理员进行设置！"
          );
        }
      }
    },

    //获取课题类别
    async getProjectCategorys() {
      const res1 = await this.axios.get(`/projectCategory/?is_active=True`);
      if (res1.status === 200) {
        this.projectCategorys = res1.data.results;
      } else {
        this.$message.warning("获取类型错误");
      }
    },

    // 课题类别下拉框改变
    // 20230505 判断青年课题、一般课题，变更参加者人数限制
    async changeCategory(event) {
      // 查找类别列表，定位类别
      this.projectCategory = this.projectCategorys.find(
        item => item.name == event
      );
      // console.log('e', this.projectCategory)
      if (
        this.projectCategory.direction == null ||
        this.projectCategory.direction.data == null
      ) {
        this.projectDirections = [];
        return this.$message.warning(`课题方向为空，请先添加课题方向！`);
      }
      this.projectDirections = this.projectCategory.direction.data;

      // 20230505 判断青年课题、一般课题，人数限制
      if (this.projectCategory.type == "一般课题") {
        this.projectMemberNumber = 9;
      } else if (this.projectCategory.type == "青年课题") {
        this.projectMemberNumber = 5;
      }

      this.$alert(
        `您选择的课题类型是“${this.projectCategory.type}”，请确认`,
        "提示",
        {
          confirmButtonText: "确定"
        }
      );
    },

    // 课题方向下拉框改变
    changeDirection(event) {
      this.projectNames = this.projectDirections.find(
        item => item.name == event
      ).projectNames;
      // console.log('pnames', this.projectNames)
    },

    // 获取课题状态
    async getProjectStatus() {
      const res = await this.axios.get(`/projectStatus/`);
      if (res.status === 200) {
        this.projectStatus = res.data;
      } else {
        this.$message.warning("错误");
      }
    },

    // 获取课题信息
    async getProjectInfo() {
      const res = await this.axios.get(`/projectInfo/?leader=${this.userid}`);
      if (res.status === 200) {
        this.projectInfo = res.data.results;
      } else {
        this.$message.warning("错误");
      }
    },

    // 查询课题信息
    async queryProjectInfo() {
      const res = await this.axios.get(
        `/projectInfo/?leader=${this.userid}&search=${this.query}`
      );
      if (res.status === 200) {
        this.projectInfo = res.data.results;
      } else {
        this.$message.warning("错误");
      }
    },

    // 获取附件列表
    async getFileList(pid) {
      const res = await this.axios.get(`/fileList/?pid=${pid}`);
      if (res.status === 200) {
        this.fileList = res.data.results;
        // console.log('file', this.fileList)
        // 排序，生成png时需要顺序
        // 先判断长度是否小于3，因为管理员审核时可能会删除文件，this.fileList = listTemp会有空值报错
        if (this.fileList.length >= 3) {
          let listTemp = [];
          let listTemp1 = [];
          for (let i = 0; i < this.fileList.length; i++) {
            // 申请书放首位，生成pdf和png时有顺序
            if (this.fileList[i].name.indexOf("申请书") != -1) {
              listTemp[0] = this.fileList[i];
            }
            else if (this.fileList[i].name.indexOf("前期研究成果") != -1) {
              listTemp[1] = this.fileList[i];
            }
            else if (this.fileList[i].name.indexOf("在研课题证明") != -1) {
              listTemp[2] = this.fileList[i];
            } else {
              // 剩余放入listTemp1
              listTemp1.push(this.fileList[i])
            }
          }
          // 组成新列表
          for (let i = 0; i < listTemp1.length; i++) {
            listTemp.push(listTemp1[i])
          }

          // 去空值，赋值
          this.fileList = listTemp.filter(Boolean)
          // console.log('file1', this.fileList)
        }
      } else {
        this.$message.warning("获取文件列表错误");
      }
    },

    // 获取审核信息
    async getAuditInfo(pid) {
      this.auditInfo = {};
      const res = await this.axios.get(`/auditInfo/?pid=${pid}`);
      // if (res.status === 200) {
      if (res.data.results[0]) {
        this.auditInfo = res.data.results[0];
        this.auditContent = this.auditInfo.info;
      }
    },

    // 查询主持人信息
    async getProjectLeader() {
      const res = await this.axios.get(`/user/?userid=${this.userid}`);
      if (res.status === 200) {
        this.projectLeader = res.data.results;
        this.leader = this.projectLeader[0];
      } else {
        this.$message.warning("错误");
      }
    },

    // 修改主持人信息
    showEditLeader() {
      this.editLeaderVisible = true;
    },
    editLeader() {
      this.$confirm("此操作将修改用户信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const res = await this.axios.put(
            `/user/${this.leader.userid}/`,
            this.leader
          );
          if (res.status !== 200) {
            return this.$message.error("更新用户状态失败");
          }
          this.$message.success("修改成功!");
          this.editLeaderVisible = false;
        })
        .catch(() => {
          this.$message.error("修改失败");
        });
    },

    // 查询参加者
    async getProjectMember(id) {
      const res = await this.axios.get(`/projectMember/?pid=${id}`);
      if (res.status === 200) {
        this.projectMember = res.data.results;
      } else {
        this.$message.warning("错误");
      }
    },

    // 新增参加者
    showAddMember() {
      if (this.projectMember.length >= this.projectMemberNumber) {
        return this.$message.error(
          "主要参加者人数大于" + this.projectMemberNumber + "，请先删除！"
        );
      }
      this.addMemberVisible = true;
      this.addMember = {};
    },
    addMemberButton() {
      this.projectMember.push(this.addMember);
      this.addMemberVisible = false;
      this.addMember = {};
    },

    // 修改参加者
    // 0420弃用el-table形式
    // showEditMember (index) {
    //   this.editMemberVisible = true
    //   this.addMember = this.projectMember[index]
    // },
    showEditMember(m) {
      this.editMemberVisible = true;
      // 查找到匹配的member
      let index = 0;
      for (let i = 0; i < this.projectMember.length; i++) {
        if (m == this.projectMember[i]) {
          index = i;
        }
      }
      this.addMember = this.projectMember[index];
    },
    editMemberButton() {
      this.editMemberVisible = false;
    },

    // 删除参加者
    // 0420弃用el-table形式
    // deleteMemberButton (index) {
    //   this.projectMember.splice(index, 1)
    // },
    deleteMemberButton(m) {
      // 查找到匹配的member
      let index = 0;
      for (let i = 0; i < this.projectMember.length; i++) {
        if (m == this.projectMember[i]) {
          index = i;
        }
      }

      this.projectMember.splice(index, 1);
    },

    //获取状态名称
    //0610  二次处理，除了1、 3,其余都显示提交成功！
    statusName(id) {
      let name = "";
      this.projectStatus.forEach(s => {
        if (s.s_id == id) {
          name = s.status;
        }
      });
      if (id == 1 || id == 3) {
        return name;
      } else {
        return "提交成功";
      }
    },

    // 显示新增申报书卡片
    showAddForm() {
      // 计算字数
      this.TiLengthAdd = this.$refs.myQuillEditorAdd.quill.getLength() - 1;

      this.addFormVisible = true;
      this.editFormVisible = false;
      this.infoFormVisible = false;
      this.fileList = [];
      this.budget = {};
      setTimeout(() => {
        document.getElementById("id-el-card-add").scrollIntoView({
          behavior: "smooth"
        });
      }, 200);
    },

    // 新增申报书 保存
    async addProject() {
      // 获取生日，青年课题必须小于40岁，一般课题小于60岁
      var birth = localStorage.getItem("birth");
      birth = new Date(birth);
      var d = new Date(this.endDate);

      // 计算初步年龄
      var age = d.getFullYear() - birth.getFullYear();

      // 检查生日是否已经过了，如果还没过需要减去一岁
      if (d < new Date(d.getFullYear(), birth.getMonth(), birth.getDate())) {
        age--;
      }

      console.log('age', birth, d, age, this.projectCategory.type)

      // 判断项目类别和年龄限制
      if (this.projectCategory.type == "一般课题") {
        if (age >= 60) {
          return this.$alert("您的年龄大于60岁，不能申报一般课题！");
        }
      } else if (this.projectCategory.type == "青年课题") {
        if (age >= 40) {
          return this.$alert("您的年龄大于40岁，不能申报青年课题！");
        }
      }

      // 20230426新增字数限制
      if (this.TiLengthAdd > this.TiLengthTotal) {
        return this.$alert(
          `您的课题研究计划超过${this.TiLengthTotal}字，请进行修改！`
        );
      }

      //课题组成员最少1人
      if (this.projectMember.length < 1) {
        return this.$alert("课题组成员不得少于1人，请先修改成员！");
      }

      // 课题方向不为空
      if (this.addForm.category_direction == null) {
        return this.$message.error("请选择课题方向！");
      }
      // 判断预算是否为空
      if (!this.budget.reason) {
        return this.$message.error("请填写课题经费测算依据！");
      }
      if (JSON.stringify(this.budget) === "{}") {
        return this.$message.error("请填写课题经费预算！");
      }

      // 写projectInfo
      this.addForm.category = this.projectCategory.name;
      this.addForm.leader = this.userid;
      this.addForm.leader_name = this.username;
      this.addForm.pid = this.pid;
      this.addForm.status = 1;
      this.addForm.budget = this.budget;

      const resProject = await this.axios.post(`/projectInfo/`, this.addForm);
      if (resProject.status !== 201) {
        return this.$message.error("新增申报书失败");
      }
      // 写projectMember
      for (var i = 0; i < this.projectMember.length; i++) {
        this.projectMember[i].pid = this.pid;
        let res = await this.axios.post(
          `/projectMember/`,
          this.projectMember[i]
        );
        if (res.status !== 201) {
          return this.$message.error(
            "新增参加者失败，请稍后在“编辑申报书”中添加"
          );
        }
      }
      this.$message.success("保存成功");
      setTimeout(() => {
        location.reload();
      }, 500);
    },

    // 新增申报书 提交审核
    async submitProject() {
      // 20230426新增字数限制
      if (this.TiLengthAdd > this.TiLengthTotal) {
        return this.$alert(
          `您的课题研究计划超过${this.TiLengthTotal}字，请进行修改！`
        );
      }

      //课题组成员最少1人
      if (this.projectMember.length < 1) {
        return this.$alert("课题组成员不得少于1人，请先修改成员！");
      }

      // 获取生日，青年课题必须小于40岁，一般课题小于60岁
      var birth = localStorage.getItem("birth");
      birth = new Date(birth);
      var d = new Date(this.endDate);
      // 计算初步年龄
      var age = d.getFullYear() - birth.getFullYear();
      // 检查生日是否已经过了，如果还没过需要减去一岁
      if (d < new Date(d.getFullYear(), birth.getMonth(), birth.getDate())) {
        age--;
      }
      // 判断项目类别和年龄限制
      if (this.projectCategory.type == "一般课题") {
        if (age >= 60) {
          return this.$alert("您的年龄大于60岁，不能申报一般课题！");
        }
      } else if (this.projectCategory.type == "青年课题") {
        if (age >= 40) {
          return this.$alert("您的年龄大于40岁，不能申报青年课题！");
        }
      }

      // 判断预算是否为空
      if (JSON.stringify(this.budget) === "{}") {
        return this.$message.error("请填写课题经费预算！");
      }
      // 判断文件列表中的文件名
      let indexOf1 = 0;
      let indexOf2 = 0;
      let indexOf3 = 0;
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].name.indexOf("前期研究成果") != -1) {
          indexOf1 = 1;
        }
        if (this.fileList[i].name.indexOf("在研课题证明") != -1) {
          indexOf2 = 1;
        }
        if (this.fileList[i].name.indexOf("申请书") != -1) {
          indexOf3 = 1;
        }
      }
      if (indexOf1 == 0) {
        return this.$message.error("请上传《前期研究成果》！");
      } else if (indexOf2 == 0) {
        return this.$message.error("请上传《在研课题证明》！");
      } else if (indexOf3 == 0) {
        return this.$message.error("请上传《申请书》！");
      }

      // 写projectInfo
      this.addForm.leader = this.userid;
      this.addForm.leader_name = this.username;
      this.addForm.category = this.projectCategory.name;
      this.addForm.pid = this.pid;
      this.addForm.status = 2;
      this.addForm.budget = this.budget; //预算

      // 使用loading加载，客户等待
      const loading = this.$loading({
        lock: true, //lock的修改符--默认是false
        text: "Loading", //显示在加载图标下方的加载文案
        spinner: "el-icon-loading", //自定义加载图标类名
        background: "rgba(0, 0, 0, 0.7)", //遮罩层颜色
        target: document.querySelector("#table") //loadin覆盖的dom元素节点
      });

      const resProject = await this.axios.post(`/projectInfo/`, this.addForm);
      if (resProject.status !== 201) {
        return this.$message.error("新增申报书失败");
      }
      // 写projectMember

      for (var i = 0; i < this.projectMember.length; i++) {
        this.projectMember[i].pid = this.pid;
        let res = await this.axios.post(
          `/projectMember/`,
          this.projectMember[i]
        );
        if (res.status !== 201) {
          return this.$message.error(
            "新增参加者失败，请稍后在“编辑申报书”中添加"
          );
        }
      }
      //成功回调函数停止加载
      loading.close();

      this.$message.success("保存成功");

      //11-28 取消
      //生成上传文件的png，后面供专家查看
      // this.pdfToPng()

      setTimeout(() => {
        location.reload();
      }, 500);
    },

    // 显示查看申报书卡片（）
    showInfoForm(item) {
      this.infoFormVisible = true;
      this.addFormVisible = false;
      this.editFormVisible = false;
      this.editForm = item;

      this.getProjectMember(item.pid);
      this.getFileList(item.pid);
      setTimeout(() => {
        document.getElementById("id-el-card-info").scrollIntoView({
          behavior: "smooth"
        });
      }, 500);
    },

    // 显示编辑申报书卡片
    showEditForm(item) {
      // 计算字数
      this.TiLengthEdit = this.$refs.myQuillEditorAdd.quill.getLength() - 1;

      this.editFormVisible = true;
      this.infoFormVisible = false;
      this.addFormVisible = false;

      this.editForm = item;
      // 坑 ，编辑器内容不能直接取值，必须通过中间变量取值。否则无法正常编辑
      this.editContent = item.content;
      this.leader_introduction_temp = item.leader_introduction;

      this.getProjectMember(item.pid);
      this.getFileList(item.pid);
      this.getAuditInfo(item.pid);

      //预算表
      this.budget = item.budget;
      setTimeout(() => {
        document.getElementById("id-el-card-edit").scrollIntoView({
          behavior: "smooth"
        });
      }, 500);
    },

    // 编辑申报书，保存
    async editProject() {
      // 20230426新增字数限制
      if (this.TiLengthEdit > this.TiLengthTotal) {
        return this.$alert(
          `您的课题研究计划超过${this.TiLengthTotal}字，请进行修改！`
        );
      }

      //课题组成员最少1人
      if (this.projectMember.length < 1) {
        return this.$alert("课题组成员不得少于1人，请先修改成员！");
      }
      // 获取生日，青年课题必须小于40岁，一般课题小于60岁
      var birth = localStorage.getItem("birth");
      birth = new Date(birth);
      var d = new Date(this.endDate);
      var age =
        d.getFullYear() -
        birth.getFullYear() -
        (d.getMonth() < birth.getMonth() ||
          (d.getMonth() == birth.getMonth() && d.getDate() < birth.getDate())
          ? 1
          : 0);
      if (this.projectCategory.type == "一般课题") {
        if (age > 60) {
          return this.$alert("您的年龄大于60岁，不能申报一般课题！");
        }
      } else if (this.projectCategory.type == "青年课题") {
        if (age > 40) {
          return this.$alert("您的年龄大于40岁，不能申报青年课题！");
        }
      }

      // 写projectInfo
      this.editForm.leader = this.userid;
      this.editForm.leader_name = this.username;
      this.editForm.status = 1;

      this.editForm.content = this.editContent; //quill的坑
      this.editForm.leader_introduction = this.leader_introduction_temp;

      this.editForm.budget = this.budget; //预算
      const resProject = await this.axios.put(
        `/projectInfo/${this.editForm.id}/`,
        this.editForm
      );

      if (resProject.status !== 200) {
        return this.$message.error("编辑申报书失败");
      }
      // 写projectMember
      // 1、删除原有成员
      let resDelete = await this.axios.get(
        `/projectMember/?pid=${this.editForm.pid}`
      );
      let memberTemp = resDelete.data.results;
      for (var i = 0; i < memberTemp.length; i++) {
        let res = await this.axios.delete(`/projectMember/${memberTemp[i].id}`);
      }
      // 2、新增
      for (var i = 0; i < this.projectMember.length; i++) {
        this.projectMember[i].pid = this.editForm.pid;
        let res = await this.axios.post(
          `/projectMember/`,
          this.projectMember[i]
        );
        if (res.status !== 201) {
          return this.$message.error("新增参加者失败，请稍后再试");
        }
      }
      this.$message.success("保存成功");
      setTimeout(() => {
        location.reload();
      }, 500);
    },

    // 编辑申报书，提交
    async submitProjectEdit() {
      // 20230426新增字数限制
      if (this.TiLengthEdit > this.TiLengthTotal) {
        return this.$alert(
          `您的课题研究计划超过${this.TiLengthTotal}字，请进行修改！`
        );
      }
      //课题组成员最少1人
      if (this.projectMember.length < 1) {
        return this.$alert("课题组成员不得少于1人，请先修改成员！");
      }
      // 获取生日，青年课题必须小于40岁，一般课题小于60岁
      var birth = localStorage.getItem("birth");
      birth = new Date(birth);
      var d = new Date(this.endDate);
      var age =
        d.getFullYear() -
        birth.getFullYear() -
        (d.getMonth() < birth.getMonth() ||
          (d.getMonth() == birth.getMonth() && d.getDate() < birth.getDate())
          ? 1
          : 0);
      if (this.projectCategory.type == "一般课题") {
        if (age > 60) {
          return this.$alert("您的年龄大于60岁，不能申报一般课题！");
        }
      } else if (this.projectCategory.type == "青年课题") {
        if (age > 40) {
          return this.$alert("您的年龄大于40岁，不能申报青年课题！");
        }
      }

      // 判断附件列表，小于3返回
      // if (this.fileList.length < 3) {
      //   return this.$message.error('请上传《申请书》、《前期研究成果》、《在研课题证明》！')
      // }
      // 判断文件列表中的文件名
      // console.log(this.fileList.length)
      let indexOf1 = 0;
      let indexOf2 = 0;
      let indexOf3 = 0;

      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].name.indexOf("前期研究成果") != -1) {
          indexOf1 = 1;
        }
        if (this.fileList[i].name.indexOf("在研课题证明") != -1) {
          indexOf2 = 1;
        }
        if (this.fileList[i].name.indexOf("申请书") != -1) {
          indexOf3 = 1;
        }
      }

      if (indexOf1 == 0) {
        return this.$message.error("请上传《前期研究成果》！");
      } else if (indexOf2 == 0) {
        return this.$message.error("请上传《在研课题证明》！");
      } else if (indexOf3 == 0) {
        return this.$message.error("请上传《申请书》！");
      }

      // 写projectInfo
      this.editForm.leader = this.userid;
      this.editForm.leader_name = this.username;
      this.editForm.status = 2;
      this.editForm.content = this.editContent;
      this.editForm.budget = this.budget; //预算

      // 使用loading加载，客户等待
      const loading = this.$loading({
        lock: true, //lock的修改符--默认是false
        text: "Loading", //显示在加载图标下方的加载文案
        spinner: "el-icon-loading", //自定义加载图标类名
        background: "rgba(0, 0, 0, 0.7)", //遮罩层颜色
        target: document.querySelector("#table") //loadin覆盖的dom元素节点
      });

      const resProject = await this.axios.put(
        `/projectInfo/${this.editForm.id}/`,
        this.editForm
      );

      if (resProject.status !== 200) {
        return this.$message.error("编辑申报书失败");
      }
      // 写projectMember
      // 1、删除原有成员
      let resDelete = await this.axios.get(
        `/projectMember/?pid=${this.editForm.pid}`
      );
      let memberTemp = resDelete.data.results;
      for (var i = 0; i < memberTemp.length; i++) {
        let res = await this.axios.delete(`/projectMember/${memberTemp[i].id}`);
      }
      // 2、新增
      for (var i = 0; i < this.projectMember.length; i++) {
        this.projectMember[i].pid = this.editForm.pid;
        let res = await this.axios.post(
          `/projectMember/`,
          this.projectMember[i]
        );
        if (res.status !== 201) {
          return this.$message.error("新增参加者失败，请稍后再试");
        }
      }

      //生成上传文件的png，后面供专家查看
      this.pdfToPng();

      //成功回调函数停止加载
      loading.close();

      this.$message.success("保存成功");
      setTimeout(() => {
        location.reload();
      }, 500);
    },

    // 生成申报书并下载
    async genPdf(e) {
      // 判断预算是否为空
      if (JSON.stringify(this.budget) === "{}") {
        return this.$message.error("请填写课题经费预算！");
      }
      // 使用loading加载，客户等待
      const loading = this.$loading({
        lock: true, //lock的修改符--默认是false
        text: "Loading", //显示在加载图标下方的加载文案
        spinner: "el-icon-loading", //自定义加载图标类名
        background: "rgba(0, 0, 0, 0.7)", //遮罩层颜色
        target: document.querySelector("#table") //loadin覆盖的dom元素节点
      });

      if (e == "add") {
        // 新增申报书页面
        // 课题方向不为空
        if (this.addForm.category_direction == null) {
          //停止加载
          loading.close();
          return this.$message.error("请选择课题方向！");
        }
        this.addForm.leader = this.userid;
        this.addForm.pid = this.pid;
        this.addForm.budget = this.budget; //预算
        let data = {
          project: this.addForm,
          leader: this.leader,
          member: this.projectMember
        };
        let res = await this.axios.post("/genPdf/", data);
        let fileName = {
          path: "/toPdf/pdf_temp/" + "课题申请书" + res.data.pid + ".pdf",
          name: "课题申请书" + res.data.pid + ".pdf"
        };
        //成功回调函数停止加载
        loading.close();

        this.downloadFile(fileName);
      }
      if (e == "edit") {
        // 编辑页面
        this.editForm.content = this.editContent;
        let data = {
          project: this.editForm,
          leader: this.leader,
          member: this.projectMember
        };
        let res = await this.axios.post("/genPdf/", data);
        let fileName = {
          path: "/toPdf/pdf_temp/" + "课题申请书" + res.data.pid + ".pdf",
          name: "课题申请书" + res.data.pid + ".pdf"
        };
        //成功回调函数停止加载
        loading.close();

        this.downloadFile(fileName);
      }
    },

    // 上传文件，新增申报书
    uploadFile(e) {
      if (e.target.files[0].name.slice(-3) != "pdf") {
        return this.$message.error("请上传pdf格式的文件！");
      }
      let formData = new FormData();
      let data = JSON.stringify({
        pid: this.pid
      });
      formData.append("file", e.target.files[0]);
      formData.append("data", data); // 上传文件的同时， 也可以上传其他数据
      let url = `/uploadFile/`;
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.axios.post(url, formData, config).then(response => {
        this.getFileList(this.pid);
      });
    },

    // 上传，编辑申报书，pid存在
    uploadFileEdit(e) {
      if (e.target.files[0].name.slice(-3) != "pdf") {
        return this.$message.error("请上传pdf格式的文件！");
      }
      let formData = new FormData();
      let data = JSON.stringify({
        pid: this.editForm.pid
      });
      formData.append("file", e.target.files[0]);
      formData.append("data", data); // 上传文件的同时， 也可以上传其他数据
      let url = `/uploadFile/`;
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.axios.post(url, formData, config).then(response => {
        this.getFileList(this.editForm.pid);
      });
    },

    // 删除文件
    async deleteFile(item) {
      let res = await this.axios.delete("/fileList/" + item.id + "/");
      if (res.status === 204) {
        this.getFileList(item.pid);
      }
      let data = {
        path: item.path
      };
      let resDelete = await this.axios.post("/deleteFile/", data);
      // console.log(resDelete)
    },

    // 下载文件
    downloadFile(item) {
      // console.log('下载：', item)
      // 注意：path里带有文件名
      let url = `/downloadFile/?path=${item.path}&name=${item.name}`;
      let params = {
        path: item.path,
        name: item.name
      };
      this.axios
        .post(url, params, {
          responseType: "arraybuffer"
        })
        .then(res => {
          fileDownload(res.data, item.name);
        });
    },

    // 生成上传文件的png，后面供专家查看
    async pdfToPng() {
      let res = await this.axios.post("/pdfToPng/", this.fileList);
      if (res.status != 200) {
        this.$message.error("生成图片信息失败！");
      }
    },

    // 预算按钮
    editBudget() {
      this.budgetVisible = true;
    },
    // 预算对话框确定按钮
    budgetButton() {
      this.budgetVisible = false;

      // 判断b的各个属性，如果是undefined，则赋值为0
      let keys = ['f1', 'f2', 'f3', 'f4', 'f5', 'f6', 'f7', 'f8', 'f9', 'f10', 'f11', 'f12', 'f13', 'f14', 'f15', 'f16', 'f17'];

      keys.forEach(key => {
        if (this.budget[key] === undefined) {
          this.budget[key] = 0;
        }
      });

      let b = this.budget;
      // console.log('b:', b.f1, b.f2, b.f3, b.f4, b.f5, b.f6, b.f7, b.f8, b.f9, b.f10, b.f11, b.f12, b.f13, b.f14, b.f15, b.f16, b.f17)
      // if (parseFloat(b.f1) != parseFloat(b.f2) + parseFloat(b.f15)) {
      //   this.budgetVisible = true;
      //   this.$message.error("经费总额 ≠ 直接经费 + 间接经费！");
      // } else if (
      //   parseFloat(b.f2) !=
      //   parseFloat(b.f3) +
      //   parseFloat(b.f7) +
      //   parseFloat(b.f8) +
      //   parseFloat(b.f9) +
      //   parseFloat(b.f11) +
      //   parseFloat(b.f12) +
      //   parseFloat(b.f13) +
      //   parseFloat(b.f14)
      // ) {
      //   console.log('f2', b.f2)
      //   console.log('直接经费明细', parseFloat(b.f3) +
      //     parseFloat(b.f7) +
      //     parseFloat(b.f8) +
      //     parseFloat(b.f9) +
      //     parseFloat(b.f11) +
      //     parseFloat(b.f12) +
      //     parseFloat(b.f13) +
      //     parseFloat(b.f14))
      //   this.budgetVisible = true;
      //   this.$message.error("直接经费明细计算错误！");
      // } else if (
      //   parseFloat(b.f3) !=
      //   parseFloat(b.f4) + parseFloat(b.f5) + parseFloat(b.f6)
      // ) {
      //   this.budgetVisible = true;
      //   this.$message.error("设备费细计算错误！");
      // } else if (parseFloat(b.f15) != parseFloat(b.f16) + parseFloat(b.f17)) {
      //   this.budgetVisible = true;
      //   this.$message.error("间接经费明细计算错误！");
      // } else if (parseFloat(b.f1) * 0.1 < parseFloat(b.f15)) {
      //   this.budgetVisible = true;
      //   this.$message.error("间接经费超过了总经费的10%！");
      // }
      const epsilon = 0.00001; // 设置一个小的容忍度

      if (Math.abs(parseFloat(b.f1) - (parseFloat(b.f2) + parseFloat(b.f15))) > epsilon) {
        this.budgetVisible = true;
        this.$message.error("经费总额 ≠ 直接经费 + 间接经费！");
      } else if (Math.abs(parseFloat(b.f2) - (parseFloat(b.f3) + parseFloat(b.f7) + parseFloat(b.f8) + parseFloat(b.f9) + parseFloat(b.f11) + parseFloat(b.f12) + parseFloat(b.f13) + parseFloat(b.f14))) > epsilon) {
        this.budgetVisible = true;
        this.$message.error("直接经费明细计算错误！");
      } else if (Math.abs(parseFloat(b.f3) - (parseFloat(b.f4) + parseFloat(b.f5) + parseFloat(b.f6))) > epsilon) {
        this.budgetVisible = true;
        this.$message.error("设备费细计算错误！");
      } else if (Math.abs(parseFloat(b.f15) - (parseFloat(b.f16) + parseFloat(b.f17))) > epsilon) {
        this.budgetVisible = true;
        this.$message.error("间接经费明细计算错误！");
      } else if (parseFloat(b.f1) * 0.1 < parseFloat(b.f15)) {
        this.budgetVisible = true;
        this.$message.error("间接经费超过了总经费的10%！");
      } else {
        this.budgetVisible = false;
        this.$message.success("预算计算正确！");
      }

    },

    async test() {
      let res = await this.axios.get("/test/");
      // console.log(res)
    }
  }
};
</script>

<style lang="less">
.el-card {
  margin-top: 15px;
}

.header-edit {
  font-size: 18px;
  text-align: left;
  margin-bottom: 10px;
}

.el-col-user-add {
  display: flex;
}

.user-search {
  width: 420px;
  margin-right: 10px;
}

.el-col-addForm {
  display: flex;
  margin-bottom: 10px;

  span {
    display: flex;
    align-items: center;
    margin-left: 10px;
  }

  .el-input {
    width: 400px;
  }
}

.el-card-leader {
  .div-leader {
    font-size: 24px;
    margin-bottom: 15px;
  }
}

.member {
  font-size: 16px;
  margin-bottom: 15px;
}

.el-row-detail {
  width: 1020px;

  .el-col {
    display: flex;

    span {
      display: flex;
      align-items: center;
      margin-left: 10px;
    }

    .el-input {
      width: 200px;
    }
  }
}

.editor {
  margin-top: 15px;

  .ql-editor {
    min-height: 200px;
  }

  width: 790px;
}

.editor-audit {
  .ql-editor {
    min-height: 100px;
  }
}

.div-upload {
  width: 500px;
  padding-top: 10px;
}

.div-add {
  margin-top: 20px;
  display: flex;
  justify-content: end;
}

.div-file {
  margin-top: 15px;

  .div-upload {
    height: 47px;

    .input-upload {
      width: 101px;
      height: 33px;
      position: absolute;
      z-index: 1;
      opacity: 0;
    }

    .button-upload {
      position: absolute;
    }

    .button-upload:hover {
      cursor: pointer;
    }
  }
}

.div-leader-indroduction {}

.result_type {
  .input-result-type {
    width: 640px;
    margin-top: 10px;
  }
}

.total_words {
  margin-top: 20px;
  display: flex;
  align-items: center;

  .el-input {
    width: 200px;
    margin-right: 80px;
  }
}

// 预算
.div-budget {
  display: flex;
  justify-content: center;

  table {
    border-top: 1px solid #000;
    border-left: 1px solid #000;
    border-spacing: 0;
    text-align: center;
    line-height: 40px;
  }

  td {
    padding-left: 10px;
    padding-right: 10px;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
  }

  td:nth-child(2) {
    text-align: left;
  }

  .editor {
    width: 730px;
  }

  .div-but {
    margin-top: 20px;
  }
}

// 主持人表
.leader-table {
  width: 794px;
  margin-bottom: 20px;
  line-height: 40px;

  table {
    border-top: 1px solid #000;
    border-left: 1px solid #000;
    border-spacing: 0;
    text-align: center;
    line-height: 40px;
  }

  table .col1 {
    width: 100px;
  }

  table .col2 {
    width: 50px;
  }

  table .col3 {
    width: 150px;
  }

  .table-member {
    border-top: 0;
    border-left: 1px solid #000;
    border-spacing: 0;
  }

  td,
  th {
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
  }

  .th1 {
    width: 30px;
    line-height: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/project/ProjectAdd.vue